import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// returns current tenderId
export const useTenderId = () => {
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  const tenderIdFromSearch = params.get('tenderId');

  const parseTenderId = () => {
    const paths = pathname.split('/').filter(Boolean);
    if (!paths[2] || !(paths[2] === 'tenders' || paths[0] === 'my-tenders'))
      return undefined;
    // no current project
    if (!paths[3]) return undefined;
    return Number(paths[3]);
  };
  const [tenderId, setTenderId] = useState<number | undefined>(parseTenderId);

  useEffect(() => {
    if (tenderIdFromSearch) {
      setTenderId(Number(tenderIdFromSearch));
    } else {
      setTenderId(parseTenderId());
    }
  }, [pathname, search]);

  return tenderId;
};
